"use client";

import React from "react";
import { Navbar, Footer } from "@/components/layout/NavbarFooter";
import { useLanguage } from "@/context/LanguageContext";

export default function PrivacyPolicy() {
  const { t } = useLanguage();

  return (
    <>
      <Navbar />
      <main className="min-h-screen bg-[#040d21] pt-32 pb-20 selection:bg-[#00f3ff] selection:text-[#040d21]">
        {/* Decorative elements */}
        <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-[#0066ff]/5 rounded-full blur-[120px] pointer-events-none" />
        <div className="absolute bottom-0 right-1/4 w-[400px] h-[400px] bg-[#00f3ff]/5 rounded-full blur-[100px] pointer-events-none" />

        <div className="max-w-5xl mx-auto px-6 relative z-10">
          <div className="bg-[#0a192f]/60 backdrop-blur-2xl rounded-[3rem] border border-[#00f3ff]/10 p-8 md:p-16 shadow-[0_20px_50px_rgba(0,0,0,0.5)] group hover:border-[#00f3ff]/20 transition-all duration-500">
            <h1 className="text-4xl md:text-6xl font-black text-white mb-12 tracking-tighter leading-tight">
              Chính sách Bảo mật{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00f3ff] to-[#0066ff] drop-shadow-[0_0_15px_rgba(0,243,255,0.3)]">
                AHV Holding
              </span>
            </h1>

            <div className="space-y-10 text-slate-300 font-medium leading-relaxed">
              <section>
                <p className="text-lg">
                  Chính sách bảo mật này áp dụng cho ứng dụng AHV Work (sau đây gọi tắt là
                  &quot;Ứng dụng&quot;) dành cho thiết bị di động, được tạo bởi AHV Holding
                  (sau đây gọi tắt là &quot;Nhà cung cấp Dịch vụ&quot;) dưới dạng dịch vụ Miễn phí. Dịch vụ
                  này được cung cấp &quot;NGUYÊN TRẠNG&quot;.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Thu thập và Sử dụng Thông tin
                </h2>
                <p>
                  Ứng dụng thu thập thông tin khi bạn tải xuống và sử dụng. Thông tin
                  này có thể bao gồm:
                </p>
                <ul className="list-none space-y-3 pl-4">
                  {[
                    "Địa chỉ Giao thức Internet (IP) của thiết bị của bạn",
                    "Các trang trong Ứng dụng mà bạn truy cập, thời gian và ngày truy cập, thời gian bạn dành cho các trang đó",
                    "Thời gian bạn sử dụng Ứng dụng",
                    "Hệ điều hành bạn sử dụng trên thiết bị di động của mình",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#00f3ff] shadow-[0_0_8px_#00f3ff] flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <p>
                  Ứng dụng không thu thập thông tin chính xác về vị trí của thiết bị
                  di động của bạn.
                </p>
              </section>

              <section className="space-y-4">
                <p>
                  Nhà cung cấp Dịch vụ có thể sử dụng thông tin bạn cung cấp để liên hệ
                  với bạn theo thời gian nhằm cung cấp cho bạn các thông tin quan trọng,
                  thông báo bắt buộc và các chương trình khuyến mãi.
                </p>
                <p>
                  Để có trải nghiệm tốt hơn khi sử dụng Ứng dụng, Nhà cung cấp Dịch vụ
                  có thể yêu cầu bạn cung cấp một số thông tin cá nhân có thể nhận dạng
                  được. Thông tin mà Nhà cung cấp Dịch vụ yêu cầu sẽ được họ lưu giữ và
                  sử dụng như mô tả trong chính sách bảo mật này.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Quyền Truy cập của Bên Thứ ba
                </h2>
                <p>
                  Chỉ có dữ liệu tổng hợp, ẩn danh mới được truyền định kỳ đến các
                  dịch vụ bên ngoài để hỗ trợ Nhà cung cấp Dịch vụ cải thiện Ứng dụng
                  và dịch vụ của họ. Nhà cung cấp Dịch vụ có thể chia sẻ thông tin của bạn
                  với các bên thứ ba theo các cách được mô tả trong chính sách bảo mật này.
                </p>
                <p>
                  Xin lưu ý rằng Ứng dụng sử dụng các dịch vụ của bên thứ ba có
                  Chính sách Bảo mật riêng về việc xử lý dữ liệu. Dưới đây là các liên kết
                  đến Chính sách Bảo mật của các nhà cung cấp dịch vụ bên thứ ba được
                  Ứng dụng sử dụng:
                </p>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-6">
                  {[
                    { name: "Google Play Services", url: "https://www.google.com/policies/privacy/" },
                    { name: "AdMob", url: "https://support.google.com/admob/answer/6128543?hl=en" },
                    { name: "Google Analytics for Firebase", url: "https://firebase.google.com/support/privacy" },
                    { name: "Firebase Crashlytics", url: "https://firebase.google.com/support/privacy/" },
                    { name: "Facebook", url: "https://www.facebook.com/about/privacy/update/printable" },
                  ].map((link, i) => (
                    <a
                      key={i}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex items-center justify-between p-4 bg-[#040d21]/40 border border-[#00f3ff]/10 rounded-2xl hover:border-[#00f3ff]/40 hover:bg-[#00f3ff]/5 transition-all group/link"
                    >
                      <span className="font-bold text-white group-hover/link:text-[#00f3ff] transition-colors">{link.name}</span>
                      <span className="material-symbols-outlined text-sm text-[#00f3ff] opacity-0 group-hover/link:opacity-100 transition-all transform translate-x-[-10px] group-hover/link:translate-x-0">
                        open_in_new
                      </span>
                    </a>
                  ))}
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Công bố Thông tin
                </h2>
                <p>
                  Nhà cung cấp Dịch vụ có thể tiết lộ Thông tin do Người dùng Cung cấp
                  và Thông tin được Thu thập Tự động:
                </p>
                <ul className="list-none space-y-3 pl-4">
                  {[
                    "theo yêu cầu của pháp luật, chẳng hạn như tuân thủ trát đòi hầu tòa hoặc quy trình pháp lý tương tự;",
                    "khi họ tin tưởng một cách thiện chí rằng việc tiết lộ là cần thiết để bảo vệ quyền lợi của họ, bảo vệ sự an toàn của bạn hoặc của người khác, điều tra gian lận hoặc đáp ứng yêu cầu của chính phủ;",
                    "với các nhà cung cấp dịch vụ đáng tin cậy của họ, những người làm việc thay mặt họ, không có quyền sử dụng độc lập thông tin mà chúng tôi tiết lộ cho họ và đã đồng ý tuân thủ các quy tắc được nêu trong chính sách bảo mật này.",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-3">
                      <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#00f3ff] shadow-[0_0_8px_#00f3ff] flex-shrink-0" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Quyền Từ chối
                </h2>
                <p>
                  Bạn có thể dừng mọi hoạt động thu thập thông tin bởi Ứng dụng một cách
                  dễ dàng bằng cách gỡ cài đặt ứng dụng. Bạn có thể sử dụng quy trình
                  gỡ cài đặt tiêu chuẩn có sẵn trên thiết bị di động hoặc thông qua
                  cửa hàng ứng dụng di động.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Chính sách Lưu giữ Dữ liệu
                </h2>
                <p>
                  Nhà cung cấp Dịch vụ sẽ lưu giữ dữ liệu do Người dùng Cung cấp trong
                  suốt thời gian bạn sử dụng Ứng dụng và trong một khoảng thời gian hợp lý
                  sau đó. Nếu bạn muốn họ xóa Dữ liệu do Người dùng Cung cấp mà bạn đã
                  cung cấp thông qua Ứng dụng, vui lòng liên hệ theo địa chỉ{" "}
                  <a href="mailto:ahvholding.com@gmail.com" className="text-[#00f3ff] hover:underline">ahvholding.com@gmail.com</a>{" "}
                  và họ sẽ phản hồi trong thời gian hợp lý.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Trẻ em
                </h2>
                <p>
                  Nhà cung cấp Dịch vụ không sử dụng Ứng dụng để cố ý thu thập dữ liệu
                  từ hoặc tiếp thị đến trẻ em dưới 13 tuổi.
                </p>
                <div className="p-6 bg-[#00f3ff]/5 border border-[#00f3ff]/20 rounded-[2rem] italic">
                  Ứng dụng không hướng đến bất kỳ ai dưới 13 tuổi. Nhà cung cấp Dịch vụ
                  không cố ý thu thập thông tin cá nhân có thể nhận dạng được từ trẻ em
                  dưới 13 tuổi. Trong trường hợp Nhà cung cấp Dịch vụ phát hiện rằng một
                  trẻ em dưới 13 tuổi đã cung cấp thông tin cá nhân, Nhà cung cấp
                  Dịch vụ sẽ ngay lập tức xóa thông tin này khỏi máy chủ của họ. Nếu bạn
                  là cha mẹ hoặc người giám hộ và bạn biết rằng con bạn đã cung cấp
                  thông tin cá nhân cho chúng tôi, vui lòng liên hệ với Nhà cung cấp
                  Dịch vụ (<a href="mailto:ahvholding.com@gmail.com" className="text-[#00f3ff] hover:underline font-bold">ahvholding.com@gmail.com</a>) để họ có thể thực hiện
                  các hành động cần thiết.
                </div>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Bảo mật
                </h2>
                <p>
                  Nhà cung cấp Dịch vụ rất quan tâm đến việc bảo vệ tính bí mật của
                  thông tin của bạn. Nhà cung cấp Dịch vụ cung cấp các biện pháp bảo vệ
                  vật lý, điện tử và quy trình để bảo vệ thông tin mà Nhà cung cấp
                  Dịch vụ xử lý và lưu giữ.
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Thay đổi
                </h2>
                <p>
                  Chính sách Bảo mật này có thể được cập nhật theo thời gian vì bất kỳ lý do
                  nào. Nhà cung cấp Dịch vụ sẽ thông báo cho bạn về bất kỳ thay đổi nào
                  đối với Chính sách Bảo mật bằng cách cập nhật trang này với Chính sách
                  Bảo mật mới. Bạn nên tham khảo Chính sách Bảo mật này thường xuyên để
                  nắm bắt các thay đổi, vì việc tiếp tục sử dụng được coi là chấp thuận
                  tất cả các thay đổi.
                </p>
                <p className="font-bold text-[#00f3ff]">
                  Chính sách bảo mật này có hiệu lực từ ngày 03-02-2026
                </p>
              </section>

              <section className="space-y-4">
                <h2 className="text-2xl font-bold text-white flex items-center gap-3">
                  <span className="w-2 h-8 bg-gradient-to-b from-[#00f3ff] to-[#0066ff] rounded-full" />
                  Sự đồng ý của Bạn
                </h2>
                <p>
                  Bằng việc sử dụng Ứng dụng, bạn đồng ý với việc xử lý thông tin của bạn
                  như được nêu trong Chính sách Bảo mật này hiện tại và các bản sửa đổi
                  của chúng tôi.
                </p>
              </section>

              <hr className="border-[#00f3ff]/10 my-10" />

              <div className="text-center text-sm text-slate-400">
                <p>
                  Nếu bạn có bất kỳ câu hỏi nào liên quan đến quyền riêng tư khi sử dụng
                  Ứng dụng, vui lòng liên hệ với chúng tôi qua email tại{" "}
                  <a href="mailto:ahvholding.com@gmail.com" className="text-[#00f3ff] hover:underline font-bold">
                    ahvholding.com@gmail.com
                  </a>.
                </p>
                <p className="mt-4 opacity-50">
                  Trang chính sách bảo mật này được tạo bởi{" "}
                  <a
                    href="https://app-privacy-policy-generator.nisrulz.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:text-white"
                  >
                    App Privacy Policy Generator
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
